import { render } from "./BasePhoneNumberInput.vue?vue&type=template&id=52f7b7c6"
import script from "./BasePhoneNumberInput.vue?vue&type=script&lang=js"
export * from "./BasePhoneNumberInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__